// @flow

import React from 'react';
import { Header } from 'semantic-grab-ui/src';

const WelcomePage = () => {
  return (
    <div>
      <Header as="h3">{'Welcome to Omega'}</Header>
      <p>{'It seems you don\'t have any permissions'}</p>
    </div>);
};

export default WelcomePage;
